import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { RadiusAccountResponseTypes } from "../common/response.common";
import { asRemoveHook, asUpdateHook, get, post, postEmpty } from "./common";

export const radiusAccount = {
    record(data: typeof Requests.RadiusAccount.Record.Input) {
        return post<typeof data, RadiusAccountResponseTypes.Record>(`/radius-account/record`, data);
    },
    create(data: typeof Requests.RadiusAccount.Create.Input) {
        return post<typeof data>(`/radius-account/create`, data);
    },
    obtain(id: string) {
        return get<RadiusAccountResponseTypes.Obtain>(`/radius-account/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/radius-account/delete/${id}`);
    },
    disconnect(id: string) {
        return postEmpty(`/radius-account/disconnect/${id}`);
    },
    generateCredentials(customerId: string) {
        return get<RadiusAccountResponseTypes.GenerateCredentials>(
            `/radius-account/generate-credentials/${customerId}`,
        );
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.RadiusAccount.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/radius-account/update/${id}`, data),
                    isLoading,
                );
            };
        },
        remove(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.RadiusAccount.Remove.Input) => {
                return await asRemoveHook(
                    post<typeof data>(`/radius-account/remove/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
